import { defineMessages } from 'react-intl';

export default defineMessages({
   mhTitle: {
      id: 'tfpa.quoteandbind.views.construction.MHtitle',
      defaultMessage: 'Added Living Space - Construction Details'
   },
   title: {
      id: 'tfpa.quoteandbind.views.construction.title',
      defaultMessage: 'Additional Construction Details'
   },
   mhTitleRoofDetails: {
      id: 'tfpa.quoteandbind.views.construction.mhTitleRoofDetails',
      defaultMessage: 'Added Living Space - Roof Details'
   },
   titleRoofDetails: {
      id: 'tfpa.quoteandbind.views.construction.titleRoofDetails',
      defaultMessage: 'Roof'
   },
   messageLine1: {
      id: 'tfpa.quoteandbind.ho.wizard.construction.banner.title.lineitem.1.message',
      defaultMessage: 'Seabrook and LaPorte: 1/1/1988 - 3/1/1996',
   },
   messageLine2: {
      id: 'tfpa.quoteandbind.ho.wizard.construction.banner.title.lineitem.2.message',
      defaultMessage: "Morgan's Point: 1/1/1988 - 6/1/1996"
   },
   messageLine3: {
      id: 'tfpa.quoteandbind.ho.wizard.construction.banner.title.lineitem.3.message',
      defaultMessage: 'Pasadena and Shore Acres: 1/1/1988 - 3/1/1997'
   },
   messageLine0: {
      id: 'tfpa.quoteandbind.ho.wizard.construction.banner.title.message',
      defaultMessage: 'An Official Building Statement is required for the cities and construction dates shown below:'
   },
   titleElectrical: {
      id: 'tfpa.quoteandbind.views.construction.titleElectrical',
      defaultMessage: 'Electrical'
   },
   titlePlumbing: {
      id: 'tfpa.quoteandbind.views.construction.titlePlumbing',
      defaultMessage: 'Plumbing'
   },
   titleHeating: {
      id: 'tfpa.quoteandbind.views.construction.titleHeating',
      defaultMessage: 'Heating'
   },
   titleDwellingValidationError: {
      id: 'tfpa.quoteandbind.views.construction.titleDwellingValidation',
      defaultMessage: 'Dwelling Validation Error'
   },
   cancel: {
      id: 'tfpa.quoteandbind.views.construction.Cancel',
      defaultMessage: 'Cancel'
   }
})
